import { 
  CubeTransparentIcon, 
  ArrowsPointingInIcon, 
  CodeBracketIcon, 
  DocumentDuplicateIcon,
  ChartBarIcon,
  CogIcon,
  ShieldCheckIcon,
  ClockIcon,
  CloudArrowUpIcon,
  ChatBubbleLeftRightIcon,
  AdjustmentsHorizontalIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline'
import { useHomeStrings } from '../../../i18n'

// Icons in the same order as features.items in the locale files
const featureIcons = [
  ArrowsPointingInIcon,
  ShieldCheckIcon,
  ClockIcon,
  CogIcon,
  AdjustmentsHorizontalIcon,
  ChatBubbleLeftRightIcon,
  CloudArrowUpIcon,
  DocumentDuplicateIcon,
  ChartBarIcon,
  CubeTransparentIcon,
  CodeBracketIcon,
  CheckCircleIcon,
]

export default function Features() {
  const t = useHomeStrings().features

  return (
    <div className="mt-10 px-4">
      <div className="lg:text-center mb-12">
        <h2 className="text-base text-accent font-semibold tracking-wide uppercase">
          {t.eyebrow}
        </h2>
        <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-foreground sm:text-4xl">
          {t.heading}
        </p>
      </div>

      <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {t.items.map((feature, index) => {
          const Icon = featureIcons[index % featureIcons.length]
          return (
          <div key={feature.name} className="flex flex-col items-center text-center p-6 bg-background-elevated rounded-xl border border-border/60 shadow-sm hover:shadow-md hover:border-border transition-all duration-200">
            <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-primary text-primary-foreground">
              <Icon className="h-6 w-6" aria-hidden="true" />
            </div>
            <h3 className="mt-4 text-lg font-semibold text-foreground">{feature.name}</h3>
            <p className="mt-2 text-muted-foreground/90 text-sm">{feature.description}</p>
          </div>
          )
        })}
      </div>
    </div>
  )
}
